<div class="filling-instructions-warning zk-flex zk-items-center zk-gap-2 zk-mt-2">
	<span class="freud-icon freud-icon-info-circle filling-instructions-icon"></span>
	<p id="filling-instructions-text" freud-typography fontType="smallRegular1-5">
		{{ 'PROMPTUARY.MODAL.QUALITY_WARNING' | translate }}
		<span id="filling-instructions-more-about" class="filling-instructions-span" (click)="openQualityPage()">
			<strong>
				{{ 'PROMPTUARY.MODAL.QUALITY_WARNING_MORE_ABOUT' | translate }}
			</strong>
		</span>
	</p>
</div>